import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField/TextField';
import { WithStyles } from 'decorators/withStyles';
import { enTypeCupom, ICoupon, IExitPopUp } from 'interfaces/IExitPopUp';
import { IProductNew } from 'interfaces/product';
import React, { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import { exitPopUpService } from 'services/exitPopUpService';
import { productNewService } from '../../../../../../../services/productNewService';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';

interface IState {
  coupon?: ICoupon;
  selectedProduct?: IProductNew;
  valueCoupon?: string;
}

interface IProps {
  classes?: any;
  exitPopUp: IExitPopUp;
}

@WithStyles(() => ({
  grayDiv: {
    width: 50,
    height: 47.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ccc',
    position: 'relative',
    border: '1px solid #ccc',
    zIndex: 2,
    borderRadius: '4px 0px 0px 4px'
  },
  typeAndValue: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  value: {
    width: 195,
    display: 'flex'
  },
  inputRadius: {
    borderRadius: '0 4px 4px 0'
  },
  inputValue: {
    width: 195
  },
  labelInput: {
    zIndex: 1,
    left: 3,
    top: 5
  },
  labelSwitch: {
    margin: '10px 0 4px -8px'
  },
  alertContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem',
    margin: '0.5rem 0',
    borderRadius: '8px',
    color: '#0000009e',
    backgroundColor: '#ffc80052'
  }
}))
export default class CouponForm extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { coupon: null, valueCoupon: '', selectedProduct: null };
  }

  componentDidMount = () => {
    exitPopUpService
      .getExitPopUpProduct()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(exitPopUp =>
        this.setState({ coupon: exitPopUp?.coupon, valueCoupon: String(exitPopUp?.coupon.value) })
      );

    productNewService
      .getSelectedProduct()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(selectedProduct => this.setState({ selectedProduct }));
  };

  changeValue = (event: any) => {
    let value: string = event.target.value;
    value = value.replace(/[^\d,.]/g, '');

    this.setState({ valueCoupon: value });
  };

  submitValue = () => {
    this.checkValueCoupon();
  };

  checkValueCoupon() {
    const { exitPopUp } = this.props;
    const { coupon, valueCoupon } = this.state;

    const typeCoupon = coupon.type;

    let value = Number(valueCoupon.replace(',', '.'));

    if (typeCoupon == enTypeCupom.VALUE && this.state.selectedProduct.price < value) {
      value = Number(Number(this.state.selectedProduct.price).toFixed(2));
    }
    if (typeCoupon == enTypeCupom.PERCENTAGE && value > 100) {
      value = 100;
    }

    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      coupon: {
        ...coupon,
        value
      }
    };

    this.setState({ valueCoupon: String(value) });
    exitPopUpService.changeExitPopUp(newExitPopUp);
  }

  changeEnabled = () => {
    const { exitPopUp } = this.props;
    const { coupon } = this.state;

    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      coupon: {
        ...coupon,
        enabled: !coupon.enabled
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  changeType = (event: any) => {
    const { exitPopUp } = this.props;
    const { coupon } = this.state;

    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      coupon: {
        ...coupon,
        type: Number(event.target.value)
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  render() {
    const { coupon, valueCoupon } = this.state;
    const { classes, exitPopUp } = this.props;

    if (!coupon) {
      return null;
    }

    return (
      <div>
        <FormControlLabel
          disabled={!exitPopUp.enabled}
          classes={{ root: classes.labelSwitch }}
          onChange={this.changeEnabled}
          control={<Switch disableRipple checked={coupon.enabled} />}
          label="Ativar Desconto"
        />
        <div>
          {coupon?.enabled && (
            <div className={classes.alertContainer}>
              <AlertCircleOutlineIcon style={{ width: '3.125rem', height: '3.125rem' }} />
              Para compras internacionais, só são válidos cupons criados a partir de porcentagem
            </div>
          )}
          <div className={classes.typeAndValue}>
            <FormControl className={classes.inputValue} disabled={!coupon.enabled}>
              <InputLabel classes={{ root: classes.labelInput }} htmlFor="age-customized-native-simple">
                Tipo
              </InputLabel>
              <Select
                value={coupon.type}
                onChange={this.changeType}
                onBlur={this.submitValue}
                autoWidth={false}
                displayEmpty
                disableUnderline={true}
              >
                <MenuItem value={enTypeCupom.PERCENTAGE}>Porcentagem</MenuItem>
                <MenuItem value={enTypeCupom.VALUE}>Valor</MenuItem>
              </Select>
            </FormControl>
            <div className={classes.value}>
              <div className={classes.grayDiv}>
                {coupon ? (coupon.type === enTypeCupom.PERCENTAGE ? '%' : 'R$') : 'R$'}
              </div>
              <TextField
                disabled={!coupon.enabled}
                onChange={this.changeValue}
                onBlur={this.submitValue}
                InputLabelProps={{
                  classes: { root: classes.labelInput }
                }}
                value={valueCoupon}
                InputProps={{
                  classes: { root: classes.inputRadius },
                  inputProps: {
                    min: 1,
                    max:
                      coupon.type == enTypeCupom.PERCENTAGE ? 100 : Number(this.state.selectedProduct.price).toFixed(2)
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
